<template>
    <div class="wrapper">


<el-dialog
  :title="$t('tips')"
  :visible.sync="popShow"
  :before-close="handleClose"
  width="50%">
  
         <div class="info">
            <!-- <span class="label">银行卡号：</span> -->
            <span class="label">{{$t('bankcardnumber')}}：</span>
            
            <div class="r">
                <el-input type="text" style="width: 217px" class="input" v-model="form.cardNumber" @blur="blur"> </el-input>
            </div>
        </div>

        <div class="info">
            <!-- <span class="label">持卡人：</span> -->
            <span class="label">{{$t('cardholder')}}</span>
            
            <div class="r">
                <el-input type="text" style="width: 217px" class="input" v-model="form.accountName"></el-input>
            </div>
        </div>

        <div class="info">
            <!-- <span class="label">银行名称：</span> -->
            <span class="label">{{$t('bankname')}}：</span>

            
            <div class="r">
                <el-input type="text" :disabled="true" v-model="form.bankName" style="width: 217px" class="input"></el-input>
            </div>
        </div>

        <div class="info">
            <!-- <span class="label">银行卡类型：</span> -->
            <span class="label">{{$t('bankcardtype')}}：</span>

            <div class="r">
                <el-input type="text"  v-model="form.cardTypeName" disabled style="width: 217px" class="input"></el-input>
            </div>
        </div>

        <div class="info">
            <!-- <span class="label">开户行名：</span> -->
            <span class="label">{{$t('accountholder')}}：</span>

            <div class="r">
                <el-input type="text" v-model="form.accountBank"   style="width: 217px" class="input"></el-input>
            </div>
        </div>

        <div class="info">
            <!-- <span class="label">开户行地址：</span> -->
            <span class="label">{{$t('bankaddress')}}：</span>
            
            <div class="r">
                <el-cascader size="medium" :options="options" separator=" " :placeholder="$t('pleaseSelect')" v-model="selectedOptions"></el-cascader>

                <!-- <el-input type="text" v-model="form.accountBank" style="width: 217px" class="input"></el-input> -->
            </div>
        </div>

        <div class="info">
            <!-- <span class="label">验证码：</span> -->
            <span class="label">{{$t('verificationCode')}}：</span>

            
            <div class="r">
                <el-input type="text" style="width: 217px" class="input" v-model="form.verify_sms"></el-input>
            </div>
            <div class="submit code-btn" v-if="!verificationMsg">{{timerMsg}}s</div>
            <div class="submit code-btn" v-if="verificationMsg" @click="getCode">
                <!-- 获取验证码 -->
                {{$t('getVerificationCode')}}
            </div>

        </div>

        <div class="info">
            <span class="label">
                <!-- 设为默认 -->
                {{$t('setDefault')}}：</span>
            <div class="r">
                <el-radio v-model="form.isDefault" :label="1">
                    <!-- 是 -->
                    {{$t('yes')}}
                </el-radio>
                <el-radio v-model="form.isDefault" :label="2">
                    <!-- 否 -->
                    {{$t('no')}}
                </el-radio>
            </div>
        </div>
           <!-- <div class="info">
                <span class="label">账号：</span>
                <div class="r">
                  <el-select v-model="form.cardId" placeholder="请选择">
                    <el-option
                      v-for="item in aliArr"
                      :key="item.account_number"
                      :label="item.account_number"
                      :value="item.id">
                    </el-option>
                  </el-select>
                </div>
            </div> -->

        <!-- <div class="info">
            <span class="label">金额：</span>
            <div class="r">
                <el-input type="text" style="width: 217px" class="input" v-model="form.money"></el-input>
            </div>
            <div class="max-money">最大可提现 <span>{{$t('currencySymbol')}}{{userInfo.balance || 0}}</span></div>
        </div>  -->

        <div class="info">
            <div class="save" @click="submit">{{$t('save')}}</div>
        </div>
</el-dialog>

        <el-button @click="popShow = true">
            <!-- 添加银行卡 -->
            {{$t('addbankcard')}}
        </el-button>
        <div class="table">
            <el-table
            :empty-text="$t('noData')"
            :data="tableData"
            style="width: 100%">
            <el-table-column
                width="180"
                prop="card_number"
                :label="$t('bankcardnumber')">
            </el-table-column>
            
            <el-table-column
                prop="bank_name"
                :label="$t('bankname')"
                >
            </el-table-column>

            <el-table-column
                prop="card_type"
                :label="$t('bankcardtype')"
                >
            </el-table-column>

            <el-table-column
            :label="$t('default')"
            width="100">
            <template slot-scope="scope">
                <div v-if="scope.row.is_default == 1">
                    <el-button type="text" size="small">
                        <!-- 默认 -->
                        {{$t('default')}}
                    </el-button>
                </div>
                <div v-else>
                    <el-button style="color: #409eff" type="text" size="small" @click="setDefault(scope.row.id)">
                        <!-- 设为默认 -->
                        {{$t('setDefault')}}
                    </el-button>
                </div>
            </template>
            </el-table-column>

            </el-table> 
        </div>


      <!-- <Pagination
        v-if="tableData.length>0"
        :totalPage="totalPage"
        :limit="10"
        @changePage="handleCurrentChange"
      ></Pagination> -->
        
    </div>
</template>

<script>
import Pagination from "@/components/common/Pagination.vue";

export default {
  components: {
    Pagination
  },
    data() {
        return {
            form: {
                bankName: '',
                areaId: '',
                accountBank: '',
                accountName: '', // 持卡人
                bankCode: '',
                cardNumber: '', // 银行卡号
                cardType: '',
                isDefault: 1,
                verify_sms: '' // 验证码
            },
            selectedOptions: [],
            options: [], // 地址信息
            auth_timer: null,
            verificationMsg: true,
            timerMsg: 60, // 定义初始时间为60s
            popShow: false,
            tableData: [],
            totalPage: 0,
            page: 1,
            limit: 10

        }
    },
    created(){

        let addressList = this.$storage.get('areaList')
        this.options = this.getTreeData(addressList)


        // let addressList = this.$storage.get('areaList')
        // if (addressList.hasOwnProperty('data')) {
        // this.options = addressList.data;
        // } else {
        // this.options = addressList;
        // }
        this.getList()
    },
    methods: {

        getTreeData(data){
            for(let i=0;i<data.length;i++){
            if('children' in data[i]) {
                if(!data[i].children || data[i].children.length<1){

                // console.log(data[i].children)
                // child若为空数组，则将child设为undefined
                data[i].children=undefined;
                }else {
                // child若不为空数组，则继续 递归调用 本方法
                this.getTreeData(data[i].children);
                }
            }
            }
            return data;
        },

        handleClose() {
            this.popShow = false
        },
        setDefault(id) {
            this.$api.setDefaultBankCard({
                id
            }).then(res=> {
                if(res.status) {
                    this.$message({
                        message: res.msg,
                        type: 'success'
                    })
                    this.getList()
                } else {
                    this.$message({
                        message: res.msg,
                        type: 'warning'
                    })
                }
            })
        },
        // 银行卡数据
        getList() {
            this.$api.getBankCardList({
                page: this.page,
                limit: this.limit
            }).then(res => {
                if(res.status) {
                    this.tableData = res.data
                    // this.totalPage = Math.ceil(res.count / this.limit) 
                }
            })
        },
        handleCurrentChange() {
            this.page += 1
            this.getList()
        },
        // 提交数据
        submit() {
            const _this  = this
            _this.popShow = false
            this.form.areaId = this.selectedOptions[2]

            this.$api.addBankCard(this.form).then(res =>{
                if(res.status) {
                    this.$message({
                        message: res.msg,
                        type:"success"
                    })
                    _this.popShow = false
                    _this.getList()
                } else {
                    this.$message({
                        message: res.msg,
                        type:"warning"
                    })
                }
            })
            console.info(this.form)
        },
        getCode() {
            const _this = this
            let phone = JSON.parse(localStorage.getItem('userInfo')).mobile
            // let phone = '18623742089'

            if(phone) {
                this.$api.sms({
                    mobile: phone,
                    code: 'veri',
                    token:  localStorage.getItem('userToken')
                }).then(res =>{
                    if(res.status) {
                        _this.timerMsg = 60
                        _this.verificationMsg = false
                        _this.countDown()
                    } else {
                        this.$message({
                            message: res.msg,
                            type: 'warning'
                        })
                    }
                    
                })
            }
            // console.log(.mobile)
        },

        countDown() {
			const _this = this
			this.auth_timer = setInterval(() => {
				// 定时器设置每秒递减
                this.timerMsg--; // 递减时间
                localStorage.setItem('timerCard', this.timerMsg)
				if (this.timerMsg-- <= 0) {
					_this.timerCard = 60
                    _this.verificationMsg = true; // 60s时间结束还原v-show状态并清除定时器
                    localStorage.removeItem('timerCard')
					clearInterval(this.auth_timer);
					auth_timer = null
				}
			}, 1000);
		},
        // 卡号失焦， 查询卡信息
      blur() {
          this.$api.getBankCardOrganization({card_code: this.form.cardNumber}).then(res => {
              if(res.status) {
                  this.form.bankName = res.data.name
                  this.form.cardTypeName = res.data.type_name
                  this.form.bankCode = res.data.bank_code
                  this.form.cardType = res.data.type
              } else {
                  this.$message({
                      message: res.msg,
                      type: 'warning'
                  })
              }
          })
      }
      
    }
}
</script>

<style lang="scss" scoped>
@import "~@/assets/css/variable.scss";
.input {
  width: 200px;
}

.code-btn {
    color: #EA4B49;
    margin-left: 20px;
}
.max-money {
  margin-left: 20px;
  color: #333;
  span {
    color: #EA4B49;
  }
}
.save {
    width: 120px;
    height: 30px;
    text-align: center;
    line-height: 30px;
    background: $theme-color;
    color: #fff;
    margin-left: 110px;
    margin-bottom: 20px;
    margin-top: 30px;
    cursor: pointer;
  }
.wrapper {
  .info {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
    padding-left: 20px;
    &:first-child {
        margin-top: 10px;
    }
    &.head {
      align-items: flex-start;
      .label {
        padding-top: 10px;
      }
    }
    .label {
      display: inline-block;
      width: 190px;
      margin-right: 20px;
    }
    .r {
      .user-head {
        width: 80px;
        height: 80px;
        border-radius: 50%;
        position: relative;
        &:hover {
          .change {
            display: block;
          }
        }
        .input-file {
          position: absolute;
          width: 100%;
          height: 100%;
          top: 0;
          left: 0;
          opacity: 0;
          cursor: pointer;
          z-index: 99;
        }
        .change {
          display: none;
          position: absolute;
          top: 50%;
          left: 50%;
          width: 70px;
          height: 18px;
          margin-left: -35px;
          line-height: 18px;
          text-align: center;
          margin-top: -8px;
          background: #757575;
          color: #fff;
          cursor: pointer;
        }
        img {
          display: block;
          width: 100%;
          height: 100%;
          border-radius: 50%;
        }
      }
      .info-input {
        width: 160px;
        height: 24px;
        line-height: 24px;
        border: 1px solid $border;
        padding-left: 12px;
      }
    }
  }
}

</style>